<section class="alerts-dialog">
  <div mat-dialog-title class="title-section">
    <span class="title" i18n="@@EmailAlertsDialogTitle">Email Alerts</span>
    <button mat-icon-button mat-dialog-close class="material-icons floatRight">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog-content">
    <form [formGroup]="emailAlertsForm">
      <div class="email-alerts-toggle">
        <mat-slide-toggle
          role="button"
          color="primary"
          [formControl]="enable"
          name="enable"
          id="email-alerts-toggle"
          i18n="@@EmailAlertsDialogToggleButton"
        >
          Enable Email Alerts
        </mat-slide-toggle>
      </div>
      <div>
        <app-input-chips
          label="Cc"
          controlName="carbonCopy"
          placeHolder="Enter email address..."
          i18n-placeHolder="@@EmailAlertsDialogToggleCarbonCopyInputPlaceHolder"
          i18n-label="@@EmailAlertsDialogToggleCarbonCopyInputLabel"
          [chips]="carbonCopyEmails"
        >
        </app-input-chips>
      </div>

      <div class="blind-carbon-copy">
        <app-input-chips
          label="Bcc"
          controlName="blindCarbonCopy"
          placeHolder="Enter email address..."
          i18n-placeHolder="
            @@EmailAlertsDialogToggleBlindCarbonCopyInputPlaceHolder"
          i18n-label="@@EmailAlertsDialogToggleBlindCarbonCopyInputLabel"
          [chips]="blindCarbonCopyEmails"
        >
        </app-input-chips>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="action-buttons">
    <button
      id="cancel-button"
      mat-stroked-button
      mat-dialog-close
      color="primary"
      i18n="@@EmailAlertsDialogBackButton"
    >
      Back
    </button>
    <button
      id="save-button"
      mat-flat-button
      mat-dialog-close
      color="primary"
      (click)="save()"
      [disabled]="isSaveBtnDisabled()"
      i18n="@@EmailAlertsDialogSaveButton"
    >
      Save Changes
    </button>
  </mat-dialog-actions>
</section>
